// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1ManagedFieldsOperationType = {
  ManagedFieldsOperationApply: 'Apply',
  ManagedFieldsOperationUpdate: 'Update',
} as const;
export type V1ManagedFieldsOperationType =
  (typeof V1ManagedFieldsOperationType)[keyof typeof V1ManagedFieldsOperationType];

export function instanceOfV1ManagedFieldsOperationType(value: any): boolean {
  for (const key in V1ManagedFieldsOperationType) {
    if (
      Object.prototype.hasOwnProperty.call(V1ManagedFieldsOperationType, key)
    ) {
      if (
        V1ManagedFieldsOperationType[
          key as keyof typeof V1ManagedFieldsOperationType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1ManagedFieldsOperationTypeFromJSON(
  json: any,
): V1ManagedFieldsOperationType {
  return V1ManagedFieldsOperationTypeFromJSONTyped(json, false);
}

export function V1ManagedFieldsOperationTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ManagedFieldsOperationType {
  return json as V1ManagedFieldsOperationType;
}

export function V1ManagedFieldsOperationTypeToJSON(
  value?: V1ManagedFieldsOperationType | null,
): any {
  return value as any;
}

export function V1ManagedFieldsOperationTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1ManagedFieldsOperationType {
  return value as V1ManagedFieldsOperationType;
}
